import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.reduce.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bba54408"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ue-call-queue-bar"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "queue-btn"
}, [/*#__PURE__*/_createElementVNode("span", null, "呼叫队列"), /*#__PURE__*/_createElementVNode("i", {
  class: "ue-ccc ue-cccDown",
  style: {
    "font-size": "12px"
  }
})], -1));
const _hoisted_3 = {
  class: "ue-flex-box ue-justify-item"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ue-blue-txt ue-border-bto ue-padding-bot"
}, "我所在的服务组", -1));
const _hoisted_5 = {
  class: "ue-padding-bot"
};
const _hoisted_6 = {
  class: "ue-blue-txt"
};
const _hoisted_7 = {
  class: "ue-queue-collapse"
};
const _hoisted_8 = {
  class: "ue-flex-box ue-justify-item"
};
const _hoisted_9 = {
  class: "ue-flex-box"
};
const _hoisted_10 = {
  class: "ue-mar-r16"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ue-black-txt1"
}, "登录：", -1));
const _hoisted_12 = {
  class: "ue-mar-r16"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ue-black-txt1"
}, "空闲：", -1));
const _hoisted_14 = {
  class: "ue-blue-txt"
};
const _hoisted_15 = {
  class: "ue-mar-r16"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ue-black-txt1"
}, "通话中：", -1));
const _hoisted_17 = {
  class: "ue-mar-r16"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ue-black-txt1"
}, "当前排队客户：", -1));
import { ref, nextTick, watch } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'callQueue',
  props: {
    callQueueBarMsg: {
      type: Array,
      default: () => {
        return [];
      }
    },
    callQueueBarTimer: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const visible = ref(false);
    const activeName = ref('');
    const popData = ref([]);
    const currentWaitSum = ref(0);
    const timers = ref(null);
    const popverShow = async () => {
      visible.value = true;
      document.addEventListener('click', clickFun);
    };
    const clickFun = async e => {
      await nextTick();
      const pop = document.getElementsByClassName('ue-call-queue-pop')[0];
      const btn = document.getElementsByClassName('queue-btn')[0];
      if (!(pop && pop.contains(e.target)) && !(btn && btn.contains(e.target))) {
        visible.value = false;
      }
    };
    //计算当前排队数
    const countCurrentQueueNum = data => {
      return data.reduce((acc, item) => acc + item.currentWait, 0);
    };
    const increaseValue = () => {
      popData.value.forEach(item => {
        item.currentQueue.forEach(item => {
          item.waitDuration++;
        });
      });
    };
    watch(props, () => {
      console.log(props.callQueueBarMsg, '????===>', props.callQueueBarTimer);
      if (props.callQueueBarMsg?.length > 0) {
        popData.value = props.callQueueBarMsg;
      }
      currentWaitSum.value = JSON.stringify(popData.value) != '{}' ? countCurrentQueueNum(popData.value) : 0;
      if (props.callQueueBarTimer) {
        // 收到socket数据时，开启定时器
        clearInterval(timers.value);
        timers.value = setInterval(increaseValue, 1000);
      }
    }, {
      immediate: true,
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_el_badge = _resolveComponent("el-badge");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_collapse_item = _resolveComponent("el-collapse-item");
      const _component_el_collapse = _resolveComponent("el-collapse");
      const _component_el_popover = _resolveComponent("el-popover");
      return _openBlock(), _createBlock(_component_el_popover, {
        placement: "bottom",
        visible: visible.value,
        "popper-class": "ue-call-queue-pop",
        width: 560
      }, {
        reference: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_badge, {
          value: currentWaitSum.value,
          max: 99,
          onClick: popverShow
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }, 8, ["value"])])]),
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createTextVNode(" 当前排队数："), _createElementVNode("span", _hoisted_6, _toDisplayString(currentWaitSum.value), 1), _createTextVNode("个 ")])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_collapse, {
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeName.value = $event),
          accordion: ""
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(popData.value, (item, index) => {
            return _openBlock(), _createBlock(_component_el_collapse_item, {
              name: item.queueNumber,
              key: index
            }, {
              title: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, _toDisplayString(item.queueName + '(' + item.queueNumber + ')'), 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_hoisted_11, _createTextVNode(_toDisplayString(item.onlineCount), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString(item.idleCount), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createTextVNode(_toDisplayString(item.callingCount), 1)]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createTextVNode(_toDisplayString(item.currentWait), 1)])])])]),
              default: _withCtx(() => [_createVNode(_component_el_table, {
                data: item.currentQueue,
                "max-height": "180",
                style: {
                  "width": "100%"
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_el_table_column, {
                  prop: "customerNumber",
                  label: "客户号码"
                }), _createVNode(_component_el_table_column, {
                  prop: "trunkNumber",
                  label: "服务号"
                }), _createVNode(_component_el_table_column, {
                  prop: "queueStartTime",
                  label: "开始时间",
                  width: "180"
                }), _createVNode(_component_el_table_column, {
                  prop: "waitDuration",
                  label: "排队时长"
                }, {
                  default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.waitDuration), 1)]),
                  _: 1
                })]),
                _: 2
              }, 1032, ["data"])]),
              _: 2
            }, 1032, ["name"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])])])]),
        _: 1
      }, 8, ["visible"]);
    };
  }
});